import { SEPARATOR } from '@/creditflowresearch/application/SearchHeaderMenu/constants';
import { HeaderMappingItem } from '@/creditflowresearch/application/actions/profile/helpers/types';
import { IMenuProfile } from '@/creditflowresearch/domain/DictionaryMapping';

export interface ISectionValidationResult {
  isValid: boolean,
  activeMapping?: HeaderMappingItem,
  profilesMenu?: IMenuProfile[][][],
}

class ValidationService {
  static validateSectionData(
    mapping: Record<string, HeaderMappingItem>,
    panelId: string,
    isHeaderInitialized: boolean,
    regionId: string,
    sectorsMenu: IMenuProfile[][][],
    industriesMenu: IMenuProfile[][][],
  ): ISectionValidationResult {
    if (!isHeaderInitialized || !mapping) {
      return { isValid: false };
    }

    const mappingKey = `${ panelId }${ SEPARATOR }${ regionId }`;
    const activeMapping = mapping[mappingKey];

    if (!activeMapping) {
      return { isValid: false };
    }

    const profilesMenu = activeMapping.sectorBlock ? sectorsMenu : industriesMenu;

    if (!profilesMenu || profilesMenu.length === 0) {
      return { isValid: false };
    }

    return {
      isValid: true,
      activeMapping,
      profilesMenu,
    };
  }
}

export default ValidationService;
